import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

const propTypes = {
  input: PropTypes.object,
  meta: PropTypes.object,
  title: PropTypes.any,
  val: PropTypes.string,
  isFullWidth: PropTypes.bool,
  noIcon: PropTypes.bool,
};

const InputRadioBox = (props) => {
  const {
    input,
    meta: { touched, error },
    title,
    val,
    isFullWidth,
    noIcon,
  } = props;
  const inputClasses = cx({
    'input-radiobox': true,
    'input-radiobox--state-error': touched && error,
    'input-radiobox--width-full': isFullWidth,
    'input-radiobox--no-icon': noIcon,
  });
  return (
    <label className={inputClasses}>
      <input
        {...input}
        type="radio"
        value={val}
        checked={val === input.value}
        className="input-radiobox__input"
      />
      <span className="input-radiobox__content">
        <span className="input-radiobox__title">
          {title}
        </span>
      </span>
    </label>
  );
};

InputRadioBox.propTypes = propTypes;

export default InputRadioBox;
